import { ResponsibleHist } from "../../../general/src/ResponsibleHist";
import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderUsers extends Layout {
    layoutResponsibleHist: ResponsibleHist;
    sourceOrders: DataSource;
    sourceResponsibleHist: DataSource;
    textboxAgentPayeeId: Textbox;
    textboxBillingUserId: Textbox;
    textboxEnteredUserId: Textbox;
    textboxOperationsUser: Textbox;
}
